<template>
  <div class="alert-mapping-modal-root">
    <transition name="modal-fade">
      <div
        v-if="addNewDataLocal"
        class="modern-modal__overlay"
        @click.self="handleClose">
        <div class="modern-modal modern-modal--xl">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">{{ title }}</h3>
              <p class="modern-modal__subtitle" v-if="editMode">
                Update alert mappings for the selected fleet group, then choose Update to save.
              </p>
              <p class="modern-modal__subtitle" v-else>
                Select a fleet group and move alerts between the master and paired lists to configure mappings.
              </p>
            </div>
            <button class="modern-modal__close" type="button" @click="handleClose">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>

          <section class="modern-modal__body">
            <div class="modern-modal__scroll">
              <form class="modal-form" @submit.prevent>
                <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                  <label class="vs-input--label">Fleet Group</label>
                  <v-select
                    @input="(x) => (fleetGroup = x.value)"
                    :clearable="false"
                    :value="getSelectValue(fleetGroup, fleet_array)"
                    :reduce="(text) => text.value"
                    label="text"
                    :options="fleet_array" />
                </div>

                <div class="mapping-columns">
                  <div class="mapping-column">
                    <vx-card class="mapping-card">
                      <template slot="no-body">
                        <div class="mapping-card__header">
                          <vs-chip>
                            <vs-avatar icon-pack="feather" icon="icon-bell" />
                            <span>Master</span>
                          </vs-chip>
                          <vs-input
                            size="small"
                            class="inputx w-full"
                            placeholder="Filter.."
                            v-model="searchA" />
                        </div>
                        <vs-list class="mapping-card__list">
                          <vs-list-item
                            v-for="(listItem, index) in filteredListA()"
                            :key="index"
                            :title="listItem.alert_name"
                            :subtitle="listItem.alert_code">
                            <template slot="avatar">
                              <span class="icon-container">
                                <feather-icon color="green" icon="ChevronRightIcon" svgClasses="w-4 h-4" />
                              </span>
                            </template>
                            <div class="mapping-card__action" @click="addThis(listItem)">
                              <feather-icon color="green" icon="PlusIcon" svgClasses="w-6 h-6" />
                            </div>
                          </vs-list-item>
                        </vs-list>
                      </template>
                    </vx-card>
                  </div>

                  <div class="mapping-column">
                    <vx-card class="mapping-card">
                      <template slot="no-body">
                        <div class="mapping-card__header">
                          <vs-chip>
                            <vs-avatar icon-pack="feather" icon="icon-bell" />
                            <span>Paired</span>
                          </vs-chip>
                          <vs-input
                            size="small"
                            class="inputx w-full"
                            placeholder="Filter.."
                            v-model="searchB" />
                        </div>
                        <vs-list class="mapping-card__list">
                          <vs-list-item
                            v-for="(listItem, index) in filteredListB()"
                            :key="index"
                            :title="listItem.alert_name"
                            :subtitle="listItem.alert_code">
                            <template slot="avatar">
                              <span class="icon-container">
                                <feather-icon color="green" icon="ChevronRightIcon" svgClasses="w-4 h-4" />
                              </span>
                            </template>
                            <div class="mapping-card__action mapping-card__action--remove" @click="removeThis(listItem)">
                              <feather-icon color="red" icon="XIcon" svgClasses="w-6 h-6" />
                            </div>
                          </vs-list-item>
                        </vs-list>
                      </template>
                    </vx-card>
                  </div>
                </div>
              </form>
            </div>
          </section>

          <footer class="modern-modal__footer">
            <vs-button
              class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
              @click="submitForm"
              v-if="!editMode"
              :disabled="fleetGroup == '' || listPaired.length == 0">
              Submit
            </vs-button>
            <vs-button
              class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
              @click="updateForm"
              v-if="editMode"
              :disabled="fleetGroup == '' || listPaired.length == 0">
              Update
            </vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="closeForm">
              Cancel
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

                  <div
                    class="vs-list--slot cursor"
                    style="color: green"
                    @click="addThis(listItem)">
                    <span>
                      <feather-icon
                        color="green"
                        icon="PlusIcon"
                        svgClasses="w-8 h-8"></feather-icon>
                    </span>
                  </div>
                </vs-list-item>
                <!--</draggable>-->
              </vs-list>
            </template>
          </vx-card>
        </vs-col>
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12">
          <vx-card>
            <template slot="no-body">
              <vs-row vs-w="12" style="border-bottom: 1px solid #ded8d8">
                <vs-col
                  style="padding: 5px"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="5"
                  vs-sm="5"
                  vs-xs="12">
                  <vs-chip>
                    <vs-avatar icon-pack="feather" icon="icon-bell" />
                    <span>Paired</span>
                  </vs-chip>
                </vs-col>
                <vs-col
                  style="padding: 7px 0 0 0"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="7"
                  vs-sm="7"
                  vs-xs="12">
                  <vs-input
                    size="small"
                    class="inputx w-full"
                    placeholder="Filter.."
                    v-model="searchB" />
                  <!--<input  type="text" v-model="searchB" class="mt-1 mb-1 vs-inputx vs-input&#45;&#45;input normal" placeholder="Search..">-->
                </vs-col>
              </vs-row>

              <!--<input type="text" v-model="searchB" class="vs-inputx vs-input&#45;&#45;input normal custom-search" placeholder="Search..">-->
              <vs-list style="height: calc(100vh - 400px); overflow: auto">
                <!--<draggable :list="listPaired" group="people" class="p-2 cursor-move">-->
                <vs-list-item
                  v-for="(listItem, index) in filteredListB()"
                  :key="index"
                  :title="listItem.alert_name"
                  :subtitle="listItem.alert_code">
                  <!--<vs-avatar @click="removeThis(listItem)" slot="avatar" text="listItem.name" />-->
                  <template slot="avatar">
                    <span class="icon-container">
                      <feather-icon
                        color="green"
                        icon="ChevronRightIcon"
                        svgClasses="w-4 h-4"></feather-icon>
                    </span>
                  </template>
                  <div
                    class="vs-list--slot cursor"
                    style="color: red"
                    @click="removeThis(listItem)">
                    <span>
                      <feather-icon
                        color="green"
                        icon="XIcon"
                        svgClasses="w-8 h-8"></feather-icon>
                    </span>
                  </div>
                </vs-list-item>
                <!--</draggable>-->
              </vs-list>
            </template>
          </vx-card>
        </vs-col>
      </vs-row>
    </form>
    <vs-divider />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
          @click="submitForm"
          v-if="!editMode"
          :disabled="fleetGroup == '' || listPaired.length == 0"
          >Submit
        </vs-button>
        <vs-button
          class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
          @click="updateForm"
          v-if="editMode"
          :disabled="fleetGroup == '' || listPaired.length == 0"
          >Update
        </vs-button>
        <!--<vs-button color="danger" class="mr-3 mb-2 btn-load-3 vs-con-loading__container" @click="deleteData" v-if="editMode">Delete</vs-button>-->
        <vs-button color="warning" type="border" class="mb-2" @click="closeForm"
          >Cancel</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    alertData: Array,
    fleetGroupData: Array,
    all_fleet: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  watch: {
    s_alert(val) {
      this.calculateFleet(val)
    },
  },
  mounted() {
    //
  },
  computed: {
    addNewDataLocal: {
      get() {
        // this.clearFields();
        let isOpen = false
        if (typeof this.addNewData === 'string') {
          const normalized = this.addNewData.trim().toLowerCase()
          if (normalized === 'true' || normalized === 'false') {
            isOpen = normalized === 'true'
          } else {
            try {
              isOpen = JSON.parse(this.addNewData)
            } catch (e) {
              isOpen = !!this.addNewData
            }
          }
        } else {
          isOpen = !!this.addNewData
        }

        if (isOpen) {
          if (this.editMode && this.dataEdit) {
            this.fleetGroup = this.dataEdit.fleet_group_id || this.dataEdit.id || ''
            this.calculateFleetEdit()
          } else {
            this.clearFields()
            this.calculateFleet()
            this.alert_array = Array.isArray(this.alertData)
              ? this.alertData.slice()
              : []
          }
        } else {
          this.clearFields()
        }

        return isOpen
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      alert_array: [],
      fleet_array: [],
      listPaired: [],
      s_alert: '',
      searchA: '',
      searchB: '',
      fleetGroup: '',
    }
  },
  methods: {
    filteredListA() {
      if (this.searchA.length > 0) {
        return this.alert_array.filter((post) => {
          return post.alert_name
            .toLowerCase()
            .includes(this.searchA.toLowerCase())
        })
      } else {
        //
        return this.alert_array
      }
    },
    filteredListB() {
      if (this.searchB.length > 0) {
        return this.listPaired.filter((post) => {
          return post.alert_name
            .toLowerCase()
            .includes(this.searchB.toLowerCase())
        })
      } else {
        return this.listPaired
      }
    },
    removeA(arr, key, val) {
      return arr.filter(function (obj) {
        return obj[key] !== val
      })
    },
    addThis(val) {
      //
      this.alert_array = this.removeA(this.alert_array, 'id', val.id)

      this.listPaired.push(val)
    },
    removeThis(val) {
      //
      this.listPaired = this.removeA(this.listPaired, 'id', val.id)
      let tmp = this.alertData.filter((x) => {
        return x.id == val.id
      })
      if (tmp.length > 0) {
        this.alert_array.push(val)
      }
    },
    handleClose() {
      this.closeForm()
    },
    calculateFleetEdit() {
      this.fleet_array = []
      //
      this.fleetGroupData.forEach((x) => {
        let cek = this.allData.filter((a) => {
          return x.fleet_group_code === a.fleet_group_code
        })
        //
        if (
          cek.length === 0 ||
          x.fleet_group_code == this.dataEdit.fleet_group_code
        ) {
          this.fleet_array.push({
            value: x.id,
            text: x.fleet_group_name,
          })
        }
      })
      this.alert_array = []
      this.listPaired = []
      this.dataEdit.alert_mapping.forEach((x) => {
        this.listPaired.push(x.alert)
      })
      let tmp = []
      //
      this.alertData.forEach((x) => {
        let cek = this.dataEdit.alert_mapping.filter((a) => {
          return x.id == a.alert_id
        })
        if (cek.length == 0) {
          tmp.push(x)
        }
      })
      this.alert_array = tmp
      //
    },
    calculateFleet(val) {
      this.fleet_array = []
      this.fleetGroupData.forEach((x) => {
        //
        let cek = this.allData.filter((a) => {
          return x.fleet_group_code === a.fleet_group_code
        })

        if (cek.length === 0) {
          this.fleet_array.push({
            value: x.id,
            text: x.fleet_group_name,
          })
        }
      })
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.listPaired = []
      this.alert_array = []
      this.fleet_array = []
      this.fleetGroup = ''
      this.searchA = ''
      this.searchB = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let alert = []
      this.listPaired.forEach((x) => {
        alert.push(x.id)
      })
      let dataForm = {
        data_alert: alert,
        fleet_group_id: this.fleetGroup,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.postAlertMapping(dataForm)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-1')
          if (res.data.status == 'true') {
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.loadingBtnStop('btn-load-1')
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          //
          this.$toast.error(err.message)
        })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteAlert(this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-3')
          this.$emit('submitModal', false)
          this.$toast.error('Data Successfully Deleted')
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-3')
          this.$toast.error(err.message)
        })
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let alert = []
      this.listPaired.forEach((x) => {
        alert.push(x.id)
      })
      let dataForm = {
        data_alert: alert,
        fleet_group_id: this.fleetGroup,
        created_by: this.$dataLocal.UserData().name,
      }
      //
      //
      REPO.updateAlertMapping(dataForm, this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-2')
          if (res.data.status == 'true') {
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-2')
          this.$toast.error(err.message)
        })
    },
  },
}
</script>
<style>
#content-area.content-area-default .alert-mapping-modal-root .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced .alert-mapping-modal-root .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .alert-mapping-modal-root .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced) .alert-mapping-modal-root .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .alert-mapping-modal-root .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }
}
</style>
<style scoped>
.alert-mapping-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(1080px, 96vw);
  max-height: 92vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal--xl {
  width: min(1080px, 96vw);
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 32px 16px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.9rem;
  line-height: 1.4;
  color: #64748b;
  max-width: 620px;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 20px 32px 32px;
  overflow: hidden;
}

.modern-modal__scroll {
  max-height: calc(92vh - 190px);
  overflow-y: auto;
  padding-right: 6px;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 32px 26px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.field-group {
  background: rgba(241, 245, 249, 0.65);
  border-radius: 14px;
  padding: 18px 18px 12px;
  border: 1px solid rgba(203, 213, 225, 0.6);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.field-group--stacked {
  white-space: normal;
}

.field-group:hover {
  border-color: rgba(148, 163, 184, 0.8);
}

.field-group:focus-within {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-input--label {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
}

.field-group span {
  display: none;
}

.field-group .vs-con-input {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field-group .vs-con-input:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-inputx.vs-input--input.normal {
  border: none;
  background: transparent;
  padding: 12px 16px;
  font-size: 0.94rem;
  line-height: 1.5;
  color: #0f172a;
}

.field-group .vs-inputx.vs-input--input.normal:focus {
  box-shadow: none;
}

.mapping-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.mapping-card {
  height: 100%;
}

.mapping-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid #e2e8f0;
}

.mapping-card__list {
  height: calc(80vh - 320px);
  overflow-y: auto;
}

.mapping-card__action {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #16a34a;
}

.mapping-card__action--remove {
  color: #b91c1c;
}

.icon-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.modern-modal ::v-deep(.vs-button) {
  min-height: 44px;
  padding: 0 22px;
  border-radius: 10px;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .modern-modal {
    width: min(940px, 96vw);
  }

  .mapping-card__list {
    height: calc(70vh - 320px);
  }
}

@media (max-width: 768px) {
  .mapping-columns {
    grid-template-columns: 1fr;
  }

  .modern-modal {
    width: min(720px, 96vw);
  }
}

.custom-search {
  position: absolute;
  width: 50%;
  right: 7px;
  top: 2px;
  z-index: 3;
}

.cursor {
  cursor: pointer;
}
</style>
